import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Detalles-tickets.css"
import { useRol } from "../../../../Context";
import { PageBase } from "../../../../Components/PageBase";
import back from "../../../../icons/arrow-back.svg"
import backCH from "../../../../icons/arrow-backCH.svg"
import forward from "../../../../icons/arrow-forward.svg"
import forwardCH from "../../../../icons/arrow-forwardCH.svg"

function DetallesTickets() {

    const { rol } = useRol()

    const navigate = useNavigate()

    const handleBack = () => {
        navigate('/Soporte')
    }

    const handleForward = () => {
        navigate('/Inicio')
    }

    const [titulo, setTitulo] = useState('');
    const [descripcion, setDescripcion] = useState('');

    const handleTituloChange = (event) => {
        setTitulo(event.target.value);
    };

    const handleDescripcionChange = (event) => {
        setDescripcion(event.target.value);
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        // Puedes realizar alguna acción con los datos del formulario aquí, por ejemplo, enviarlos a un servidor.
        // Datos del ticket
        // También puedes reiniciar el estado del formulario después de enviar los datos.
        setTitulo('');
        setDescripcion('');
    };

    const [isHovered, setIsHovered] = useState(false);
    const [isHoveredForward, setIsHoveredForward] = useState(false);

    return (
        <>
            <PageBase />
            <div className="main-content">
                <div className="general-info-ticket">
                    <div className="central-info-ticket">
                        <div className="navegacion-container-buttons">
                            <button onClick={handleBack}
                                onMouseEnter={() => setIsHovered(true)}
                                onMouseLeave={() => setIsHovered(false)}><img
                                    src={isHovered ? backCH : back}
                                    alt="Imagen" />
                                Ver todos</button>
                            <button onClick={handleForward}
                                onMouseEnter={() => setIsHoveredForward(true)}
                                onMouseLeave={() => setIsHoveredForward(false)}>Ir a inicio <img
                                    src={isHoveredForward ? forwardCH : forward}
                                    alt="Imagen" />
                            </button>
                        </div>
                        <div className="card-ticket">
                            <div className="titulo-etapa-ticket">
                                <label>Prueba 1 - primeros pasos</label>
                                {rol === 'Asesor' ? (<label>Abierto</label>) : (<select>
                                    <option value="abierto">Abierto</option>
                                    <option value="cerrado">Cerrado</option>
                                    <option value="en proceso">En proceso</option>
                                    <option value="pendiente">Pendiente</option>
                                </select>)}
                            </div>
                            <div className="info-ticket">
                                <section>
                                    <label>Usuario:</label>
                                    <label>Alicia Martinez Esquivel</label>
                                </section>
                                <section>
                                    <label>Correo:</label>
                                    <label>esquivelmartinesalicia96@gmail.com</label>
                                </section>
                                <section>
                                    <label>Apertura:</label>
                                    <label>29 de Enero de 2024 a las 16:32</label>
                                </section>
                                <section>
                                    <label>Tipo:</label>
                                    <label>Error</label>
                                </section>
                                <section>
                                    <label>Descripcion:</label>
                                    <label>Probando</label>
                                </section>
                            </div>
                        </div>
                        <div className="card-ticket">
                            <form onSubmit={handleSubmit}>
                                <input
                                    type="text"
                                    id="titulo"
                                    placeholder="Titulo del ticket"
                                    value={titulo}
                                    onChange={handleTituloChange}
                                    required
                                />
                                <textarea
                                    id="descripcion"
                                    placeholder="Describe tu problema o requisición"
                                    value={descripcion}
                                    onChange={handleDescripcionChange}
                                    required
                                    rows="8"
                                />
                                <button type="submit">Añadir comentario</button>
                            </form>
                        </div>
                        <div className="card-ticket margin-comentarios">
                            <div className="grid-comentarios-tickets">
                                <span>A</span>
                                <section>
                                    <label>prueba 1</label>
                                    <label>Aliciamartinez</label>
                                    <label>2 de Febrero de 2024 a las 19:29</label>
                                    <p>prueba</p>
                                </section>
                            </div>
                        </div>
                        <div className="card-ticket margin-comentarios">
                            <div className="grid-comentarios-tickets">
                                <span>A</span>
                                <section>
                                    <label>prueba cambio de estilos</label>
                                    <label>Aliciamartinez</label>
                                    <label>9 de Febrero de 2024 a las 12:44</label>
                                    <p>probando el placeholder......</p>
                                </section>
                            </div>
                        </div>
                        <div className="card-ticket margin-comentarios">
                            <div className="grid-comentarios-tickets">
                                <span>A</span>
                                <section>
                                    <label>probando change status</label>
                                    <label>Aliciamartinez</label>
                                    <label>14 de Febrero de 2024 a las 14:37</label>
                                    <p>probando que el cambio en el selector de estado del ticket no perjudique a la creacion del comentario</p>
                                </section>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export { DetallesTickets }